import { render } from "./TeacherAvailability.vue?vue&type=template&id=3b30aaf2&scoped=true"
import script from "./TeacherAvailability.vue?vue&type=script&lang=js"
export * from "./TeacherAvailability.vue?vue&type=script&lang=js"

import "./TeacherAvailability.vue?vue&type=style&index=0&id=3b30aaf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b30aaf2"]])

export default __exports__